module.exports = __webpack_public_path__ + "img/express.00205e7e.svg";